/* Lumessa storefront behaviour. The mockup's cart was a local stub; here the cart is Shopify's,
   so this only handles the shop filter chips and the product gallery. */
(function () {
  'use strict';

  // Shop page: filter the cards by the kind stored on each one.
  var chips = document.querySelectorAll('.chip');
  var cards = document.querySelectorAll('#shopCards .card');
  if (chips.length && cards.length) {
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var want = chip.getAttribute('data-filter');
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var shown = 0;
        cards.forEach(function (card) {
          var hit = want === 'all' || card.getAttribute('data-kind') === want;
          card.hidden = !hit;
          if (hit) shown++;
        });
        var live = document.getElementById('filterCount');
        if (live) live.textContent = shown + (shown === 1 ? ' product' : ' products');
      });
    });
  }

  // Product page: click a thumbnail to swap the main image.
  var main = document.getElementById('mainPhoto');
  if (main) {
    document.querySelectorAll('.thumb-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        if (src) main.src = src;
        document.querySelectorAll('.thumb-btn').forEach(function (o) {
          var on = o === b;
          o.classList.toggle('on', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });
  }
})();
